var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "default"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3h12V1H1v2zm0 20h12V4H1v19zM13 0H1a1 1 0 00-1 1v22a1 1 0 001 1h12a1 1 0 001-1V1a1 1 0 00-1-1z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 22a1 1 0 100-2 1 1 0 000 2",
    id: "Fill-3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "phone-selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22a1 1 0 110-2 1 1 0 010 2m6-22H6a1 1 0 00-1 1v22a1 1 0 001 1h12a1 1 0 001-1V1a1 1 0 00-1-1",
    id: "Fill-1",
    fill: "#000"
  }))));
}

SvgPhone.displayName = 'Phone';
export default SvgPhone;